import { useState } from "react";

const faqs = [
  {
    question: "Quel délai pour un dépannage à Bischwiller ?",
    answer:
      "Bischwiller se situe à une vingtaine de minutes de notre atelier. Pour une urgence, nous intervenons généralement dans les 24 heures. Pour une réparation planifiée, comptez 24 à 48 heures. Le déplacement est gratuit dans tout le Bas-Rhin, et le technicien vous appelle avant de partir pour vous confirmer l'heure d'arrivée.",
  },
  {
    question: "Le déplacement est-il facturé depuis Bischwiller ?",
    answer:
      "Non, le déplacement est entièrement gratuit. Notre zone couvre tout le Bas-Rhin, et Bischwiller en fait partie. Le technicien arrive avec son stock de pièces, diagnostique gratuitement et vous remet un devis. Vous ne payez que l'intervention réalisée, et seulement si vous acceptez le devis. Pas de frais cachés, pas de surprise.",
  },
  {
    question: "Les fenêtres des maisons anciennes de Bischwiller sont-elles réparables ?",
    answer:
      "Oui, nous réparons toutes les fenêtres, quelle que soit leur époque. Bischwiller compte des maisons de ville anciennes avec des fenêtres en bois traditionnelles et des lotissements récents avec des menuiseries PVC. Nos techniciens identifient la marque sur place et installent la pièce neuve correspondante. Toutes les marques sont prises en charge : Ferco, GU, Roto, Maco, Siegenia, Winkhaus, Aubi, Cadiou. Chaque pièce remplacée est garantie 10 ans.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Questions fréquentes — Bischwiller
          </h2>
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className="bg-rose-50 rounded-2xl border border-rose-100 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left"
                  >
                    <span className="font-semibold text-base md:text-lg text-plum-dark">
                      {faq.question}
                    </span>
                    <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center shrink-0">
                      <i className={`ri-${isOpen ? "subtract" : "add"}-line text-plum`} />
                    </div>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6 md:pb-6">
                      <p className="text-sm md:text-base text-plum-dark/80 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}